import styled from '@emotion/styled';
import BaseImage from '@base/Image';
import { mediaQuery, Fonts, Spacings } from '@styles/index';
import Link from 'next/link';
import Typography from 'aquilla/core/atoms/Typography';
import Button from 'aquilla/core/molecules/Button';
import BackgroundImage from './BackgroundImage';

const joinUsImage = 'about/un.png';

const MissionGroup = styled.div`
  width: 576px;
  position: relative;
  padding-top: 64px;
  ${mediaQuery.uptoTablet} {
    width: 100%;
    padding: 0px;
    margin-top: 40px;
  }
`;

const Options = styled(Button)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE};
  ${mediaQuery.uptoTablet} {
    margin: auto;
    width: 241px;
    height: 57px;
    font-size: ${Fonts.H4};
    line-height: ${Fonts.PARA_LINE_HEIGHT};
    font-weight: ${Fonts.SEMIBOLD};
  }
`;

const Mission = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  letter-spacing: 2px;
  color: var(--color-i-green);
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.ULTRA_SMALL};
    text-align: center;
    display: block;
    padding-top: 34px;
  }
`;

const Roles = styled(Typography)`
  font-size: ${Fonts.LARGE};
  line-height: ${Fonts.HEADER_LINE_HEIGHT};
  color: var(--color-text-secondary);
  margin-top: ${Spacings.SPACING_8B};
  margin-bottom: ${Spacings.SPACING_4B};
  display: block;
  ${mediaQuery.uptoTablet} {
    text-align: center;
    margin: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B} ${Spacings.SPACING_8B};
  }
`;

const Description = styled(Typography)`
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.LARGE_HEADING};
  line-height: ${Fonts.PARA_LINE_HEIGHT};
  color: var(--color-i-black);
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoTablet} {
    font-size: ${Fonts.H3};
    text-align: center;
  }
`;

const JoinUsImageContainer = styled.div`
  width: 560px;
  height: 500px;
  position: absolute;
  right: 0;
  top: 0;
  overflow: hidden;
  ${mediaQuery.uptoTablet} {
    grid-column: span 24;
    width: 100%;
    height: 450px;
    position: relative;
    margin-top: 40px;
  }
`;

const JoinUsImage = styled(BaseImage)`
  object-fit: cover;
  width: 100%;
`;

const JoinUs = styled.div`
  grid-column: span 24;
  height: 424px;
  position: relative;
  padding-top: 40px;
  padding-left: 48px;
  display: flex;
  box-shadow: 0px 16px 32px rgba(221, 230, 237, 0.4);
  border-radius: 8px;
  margin-top: 4px;
  overflow: hidden;
  ${mediaQuery.uptoTablet} {
    flex-direction: column-reverse;
    flex-wrap: wrap;
    height: auto;
    width: 100%;
    grid-column: span 24;
    padding: 0;
    box-shadow: unset;
  }
`;

const RoleType = styled(Typography)`
  color: var(--color-text-secondary);
`;

const JoinUsBlock = () => {
  return (
    <JoinUs>
      <MissionGroup>
        <BackgroundImage clearLeftMargin />
        <Mission>COME JOIN US</Mission>
        <Description variant="h2">
          Let’s build the future of education together
        </Description>
        <Roles as="div">
          <RoleType>Roles open in Design • Engineering • Product</RoleType>
        </Roles>
        <Link href="/careers" passHref>
          <Options label="See open positions" size="medium" variant="brand" />
        </Link>
      </MissionGroup>
      <JoinUsImageContainer>
        <JoinUsImage src={joinUsImage} layout="fill" alt="about Unacademy" />
      </JoinUsImageContainer>
    </JoinUs>
  );
};

export default JoinUsBlock;
